// Placement normalization can encode the braces, or the entire macro token.
const consentMacro = /(?:\$|%24)(?:\{|%7B)(GDPR_CONSENT_78|GDPR|US_PRIVACY)(?:\}|%7D)/gi
const cachebusterMacro = /(?:%%|%25%25)CACHEBUSTER(?:%%|%25%25)/gi

export const hasAdConsentMacros = (url: string): boolean => url.search(consentMacro) !== -1

export const replaceAdCachebuster = (url: string): string => {
    const cachebuster = `${Date.now()}${Math.floor(Math.random() * 1000000)}`
    return url.replace(cachebusterMacro, cachebuster)
}

export const resolveAdConsentMacros = (url: string): string => {
    // Didomi supplies GPP for US consent; it cannot substitute for legacy US_PRIVACY.
    const values: Record<string, string> = { GDPR: '', GDPR_CONSENT_78: '', US_PRIVACY: '' }

    if (typeof window !== 'undefined') {
        try {
            // Use available consent data; readiness is not a prerequisite for sending.
            const status = window.Didomi?.getCurrentUserStatus?.()
            if (status?.regulation) {
                const gdpr = status.regulation.toUpperCase() === 'GDPR'
                values.GDPR = gdpr ? '1' : '0'
                values.GDPR_CONSENT_78 = gdpr ? status.consent_string || '' : ''
            }
        } catch {
            // Missing consent values remain empty, without dropping the pixel.
        }
    }

    return url.replace(consentMacro, (_token, name: string) => encodeURIComponent(values[name.toUpperCase()]))
}
